import { EvaluationMark } from '@intelingu/core/interfaces/models/CardModel';
import { autobind } from 'core-decorators';
import { action } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import { lazyInject } from '@intelingu/core/IoC/container';
import { VocabularyCardStep, VocabularyCardStore } from '@intelingu/core/stores/cards/VocabularyCardStore';
import withTranslation from '@intelingu/core/utils/withTranslation';
import {AppStore} from "../../../../stores/AppStore";

export interface VocabularyPreviewProps {
    previewPlayFunc?;
    t?;
}

@withTranslation(COMMON_NS)
@observer export class VocabularyPreview extends Component<VocabularyPreviewProps, any> {

    @lazyInject(VocabularyCardStore) vocabularyCardStore: VocabularyCardStore;
    @lazyInject(AppStore) appStore: AppStore;

    @action.bound confirm() {
        this.vocabularyCardStore.step = VocabularyCardStep.ANSWER;

        if (this.vocabularyCardStore.card.inverted) {
            if (this.props.previewPlayFunc) {
                this.props.previewPlayFunc();
            }
        }

        this.appStore.tourTrigger(this.vocabularyCardStore.card.id, 'vocabularyExpanded');
    }

    componentDidMount(): void {
        document.addEventListener ("keydown", this.hotKeyListener);
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.hotKeyListener);
    }

    @autobind hotKeyListener(event) {
        if (event.which === 13 || event.keyCode === 13) {
            this.confirm();
        }
    }

    render() {
        const { t } = this.props;
        const { card } = this.vocabularyCardStore;

        return <>
            <div className={'bottom-controls tour-weiter'}>
                <button className={'view-button'} onClick={this.confirm}>{ t('trainingShowSolution') }</button>
            </div>
        </>
    }

}
